import React, { useEffect, useState } from 'react'
import CMS from '../../../../components/cms/CMS'
import PageBanner from '../../../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SortableList } from '../../../../components/form/SortedBy'
import { useParams } from 'react-router-dom'
import CrudShowcaseItemPage from './CrudShowcaseItemPage'
import { fetchShowcaseGet } from '../../../../redux/slices/showcaseGetSlice'
import { fetchModuleSort } from '../../../../redux/slices/moduleSortSlice'
import { fetchModuleDelete } from '../../../../redux/slices/moduleDeleteSlice'

const PageShowcaseItem = () => {
    const { id } = useParams()
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const page = useSelector((state) => state.showcaseGet.data)
    const status = useSelector((state) => state.showcaseGet.status)
    const lang = useSelector((state) => state.lang.lang)
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchShowcaseGet({ id: id }))
        setChanged(false)
    }

    const handleSorted = (newList) => {
        page?.modules?.forEach(async (oldItem, oldIndex) => {
            const newIndex = newList.findIndex(item => item.id === oldItem.id);
            await dispatch(fetchModuleSort({ id: oldItem.id, sort: newIndex + 1 }))
            setChanged(true)
            getData()
        });
    };

    useEffect(() => {
        getData()
    }, [dispatch, changed])

    const deleteData = async (id) => {
        await dispatch(fetchModuleDelete({ id: id }))
        getData()
    }

    return (
        <CMS>
            <PageBanner
                modal={modal}
                setModal={setModal}
                title={page?.title[lang]}
                description={t("page_management_desc")}
                buttonText={t("add_showcase")}
            />

            {status === "succeeded" ?
                <SortableList
                    setModal={setModal}
                    list={page?.modules ? [...page?.modules].sort((a, b) => a.sort - b.sort) : []}
                    onChange={handleSorted}
                    setChanged={setChanged}
                    deleteData={deleteData}
                    // contentTitle={t("design")}
                    // contentUrl="/page-design"
                    setSelectedItem={setSelectedItem}
                /> : null
            }

            <CrudShowcaseItemPage
                showMenu={modal}
                setShowMenu={setModal}
                selectedItem={selectedItem}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                id={id}
                t={t}
            />
        </CMS>
    )
}

export default PageShowcaseItem
